/* Souss & Stone — Scroll reveal + accordion */
(function () {
  'use strict';

  /* ── Scroll reveal ── */
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          revealObserver.unobserve(e.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  function initReveal() {
    // Card grids: override CSS delay → 120 ms stagger per card
    [
      { grid: '.ss-bestsellers .ss-grid-4',    cards: '.ss-product-card'   },
      { grid: '.ss-ingredients .ss-grid-3',    cards: '.ss-ingredient-card' },
      { grid: '.ss-bundles .ss-bundles__grid', cards: '.ss-bundle-card'    },
    ].forEach(({ grid, cards }) => {
      const g = document.querySelector(grid);
      if (!g) return;
      g.querySelectorAll(cards).forEach((card, i) => {
        card.style.transitionDelay = (i * 120) + 'ms';
      });
    });

    // Observe every .ss-reveal element.
    // Hero uses .ss-load-* (CSS keyframes), not .ss-reveal — excluded automatically.
    document.querySelectorAll('.ss-reveal').forEach((el) => revealObserver.observe(el));
  }

  /* ── Accordion ── */
  function initAccordions() {
    document.querySelectorAll('.ss-accordion__trigger').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.ss-accordion__item');
        const isOpen = item.classList.contains('is-open');
        item.closest('.ss-accordion')
          .querySelectorAll('.ss-accordion__item')
          .forEach((i) => {
            i.classList.remove('is-open');
            const trigger = i.querySelector('.ss-accordion__trigger');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
          });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── Sticky ATC (product page) ── */
  function initStickyAtc() {
    const bar = document.querySelector('.ss-sticky-atc');
    const atc = document.querySelector('.product-form__submit');
    if (!bar || !atc) return;
    const obs = new IntersectionObserver(
      ([e]) => bar.classList.toggle('is-visible', !e.isIntersecting),
      { threshold: 0.5 }
    );
    obs.observe(atc);
  }

  /* ── Parallax via object-position (desktop only — mobile uses native scroll) ── */
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;

    var items = Array.from(document.querySelectorAll('[data-parallax-img]')).map(function (img) {
      return {
        img:  img,
        wrap: img.closest('[data-parallax]') || img.parentElement,
        xPos: img.dataset.parallaxX || 'center'
      };
    });

    if (!items.length) return;

    (function loop() {
      var vh = window.innerHeight;
      items.forEach(function (o) {
        var r   = o.wrap.getBoundingClientRect();
        var mid = (r.top + r.height / 2) - vh / 2;
        /* Map scroll position to a 20–80% vertical pan through the image */
        var y   = 50 + (mid / (vh + r.height)) * 55;
        y = Math.max(10, Math.min(90, y));
        o.img.style.objectPosition = o.xPos + ' ' + y + '%';
      });
      requestAnimationFrame(loop);
    })();
  }

  /* ── Scroll-aware header (border + shadow appear after 30px) ── */
  function initScrollHeader() {
    const hw = document.querySelector('.header-wrapper');
    if (!hw) return;
    const toggle = () => hw.classList.toggle('ss-scrolled', window.scrollY > 30);
    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
  }

  /* ── Init ── */
  function init() {
    initReveal();
    initAccordions();
    initStickyAtc();
    initScrollHeader();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    initReveal();
    initAccordions();
  });
})();
